import React from 'react';
import { UIContext } from 'components/UIContext/UIContext';

export const useUI = () => {
  return React.useContext(UIContext);
};
